export default "__VITE_ASSET__BRHMsvWA__"